// UNSEEN CLIENT ACTIVITY: ONE SIGNAL (v1_823).
//
// The pipeline badge, the case view's "New message · Mark as seen" and the "New
// client message" email each read something different: the email and the chip
// had_updates (set by many writers, the chip naming every type other than a
// document "New message"), the pipeline row the list's own copy of it. On
// Diment VA Exchange (26/09) the client opened the return visit link and wrote
// nothing, yet the email went and the chip showed while the row did not.
//
// Now one record, collected_data.clientActivity { lastAt, lastKind, count },
// written only by the server when the client (or their delegate) actually
// writes a message, uploads a document or replies by email; never on a visit
// and never for Alex's messages. It is unseen while newer than
// collected_data.lastOfficerViewAt, which Mark as seen stamps. All three read
// clientActivityState.

const ms = (t) => { const n = t ? new Date(t).getTime() : NaN; return Number.isFinite(n) ? n : 0; };

// Lines the client app sends to Alex on its own (never saved, but a message
// with this content is never the client's writing), and the submit command.
const MACHINE_LINES = [/^i'?m back\.?$/i, /^\(i have just reopened the portal\.?\)$/i, /^i have returned after receiving a follow.?up request/i, /^submit$/i];

export function isClientAuthored(content) {
  const t = String(content == null ? '' : content).trim();
  if (!t) return false;
  return !MACHINE_LINES.some(re => re.test(t));
}

export const ACTIVITY_LABEL = { message: 'New message', document: 'New doc', email: 'Email reply', delegate: 'Delegate reply' };

// Before clientActivity existed, the client's own events set has_updates with
// these types; an unseen one still counts (no case loses its badge on deploy).
const LEGACY_CLIENT_TYPES = { client_message: 'message', message: 'message', document: 'document', email: 'email', delegate: 'delegate' };

export function clientActivityState(session) {
  const s = session || {};
  const cd = (s.collected_data && typeof s.collected_data === 'object') ? s.collected_data : {};
  const seenAt = ms(cd.lastOfficerViewAt);
  const act = cd.clientActivity && typeof cd.clientActivity === 'object' ? cd.clientActivity : null;
  if (act && act.lastAt) {
    const unseen = ms(act.lastAt) > seenAt;
    return { unseen, kind: act.lastKind || 'message', lastAt: act.lastAt, count: act.count || 1, label: ACTIVITY_LABEL[act.lastKind] || 'New message', legacy: false };
  }
  const kind = LEGACY_CLIENT_TYPES[s.last_update_type];
  const unseen = !!(s.has_updates && kind && ms(s.last_update_at) > seenAt);
  return { unseen, kind: unseen ? kind : null, lastAt: unseen ? s.last_update_at : null, count: unseen ? 1 : 0, label: unseen ? (ACTIVITY_LABEL[kind] || 'New message') : null, legacy: true };
}

export function nextClientActivity(prev, kind, at) {
  const p = prev && typeof prev === 'object' ? prev : {};
  return { lastAt: at, lastKind: kind, count: (Number(p.count) || 0) + 1, firstAt: p.firstAt || at };
}
